import store from "../store/index";
//-------------
// get fatigue
//-------------
export default function getFatigue(this_fatigue) {
  // console.log("-------------------")
  // console.log("IN getFatigue")
  //------------------
  // get all fatigues
  //------------------
  const this_store = store;
  const fatigues = this_store.getters["combat/getFatigues"];
  //--------------------------
  // get matching fatigue obj
  //--------------------------
  let obj = fatigues.find((a) => a.name == this_fatigue);
  // console.log("fatigue name = " + obj.name + " sr adj = " + obj.sr_adj)
  return obj;
}